// Модалка не нуждается в styler
/* eslint-disable styler/check-styler */

import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { ModalMobile as Modal } from '@alfalab/core-components-modal/mobile';
import { Stack } from '@alfa-bank/site-stack';

import { ModalV2 as Component } from '../modal-v2';
import type { TModalV2Mobile, IDeps } from '../models';

export const ModalV2Mobile = createWidget<IDeps, TModalV2Mobile>({
    Modal,
    Stack,
})(Component);
